<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <v-btn
        :class="{ 'show-btn-on-hover': hover }"
        :color="color"
        :disabled="disabled"
        icon
        v-on="tooltip ? on : false"
        @click="$emit('handler')"
      >
        <v-icon small :class="{ 'show-btn-on-hover': hover }" :color="color">
          {{ icon }}
        </v-icon>
      </v-btn>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "rgba(255, 255, 255, 0)",
    },
    icon: {
      type: String,
      default: "edit",
    },
    hover: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      default: "",
    },
  },
};
</script>
